export default {
  contextualAppBar: false
}
